<template>
  <div class="regCoremailForm">
    <el-form :model="regInfo" :rules="rules" ref="regInfo" class="regForm" label-width="100px">
        <el-form-item class="infoInput" prop="email" label="邮箱地址">
          <el-input v-model="regInfo.xgh" class="emailAddr" readonly="true" maxlength="25">
          </el-input>
          <span class="emailName">@tongji.edu.cn</span>
        </el-form-item>

         <el-form-item class="infoInput mt25" prop="ownAlias"  :error="errorMsg" label="个性化别名" >          
          <el-tooltip class="item" effect="light"  placement="bottom-start" trigger="hover">
            <div slot="content">电子邮箱一旦注册成功，其个性化（前缀）邮件名将不能更改，<br/>请慎重填写。考虑到未来留学或工作申请等需要，建议选择与<br/>名字相关且容易记忆的个性化邮件名</div>
            <el-input v-model="regInfo.ownAlias" class="emailAddr" maxlength="25"></el-input>
          </el-tooltip>
          <span class="emailName">@tongji.edu.cn</span>
          <p class="tips"> 2~18个字符，可使用字母、数字、下划线，需以字母开头</p>
        </el-form-item>

   
         <el-form-item class="infoInput" v-if="regInfo.alias.length > 0 " prop="alias" label="别名" >
           <el-input v-model="regInfo.aliasStr" readonly="true" maxlength="25"></el-input>
            <p class="tips"></p>
        </el-form-item>
        <el-form-item class="infoInput mb75" prop="pwd" label="密码">
            <el-input v-model="regInfo.pwd" type="password" placeholder="请输入" maxlength="25"></el-input>
            <p class="tips"> 8-16个字符且至少包含三种字符：大写字母、小写字母、符号（不包含特殊符号）和数字</p>
        </el-form-item>
        <el-form-item class="infoInput" prop="pwd2" label="确认密码">
            <el-input v-model="regInfo.pwd2" type="password" placeholder="确认密码" maxlength="25"></el-input>
            <p class="tips"> 请再次填写密码</p>
        </el-form-item>
         
        <el-form-item class="infoBtn" >
            <el-button type="primary" @click="regEmail()">注册邮箱</el-button>
        </el-form-item>
    </el-form>
    <!-- 消息提示栏 -->
    <el-dialog
      :visible.sync="successInfo"
      custom-class="showBox"
      width="467px"
      :close-on-click-modal="boxCloseInfo"
      :close-on-press-escape="boxCloseInfo"
      :show-close="boxCloseInfo"
      center>
      <span class="boxTitle">亲爱的校友:</span>
      <p class="boxBody">恭喜您! <span class="emilName">{{regInfo.xgh}}@tongji.edu.cn </span>  邮箱已经注册成功</p>
      <span slot="footer" class="dialog-footer">
        <a href="https://mail.tongji.edu.cn" class="boxBtn" type="primary">开始使用</a>
      </span>
    </el-dialog>
  </div>
</template>

<script>



export default {
  name: "regCoremailForm",
  props: ["userInfo"],
  data() {
  const PwdPatrn = str => {
    const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
    return reg.exec(str);
  };

var PwdPatrn2 = str =>{
  const reg = this.regInfo.officeMail;
  const reg2 =reg.toLowerCase();
  const str2 = str.toLowerCase();
  return str2.indexOf(reg2); 
}
    var checkEmail = (rule, value, callback) => {
      var email = /^[a-zA-Z][a-zA-Z0-9_]*$/;
      if (value === "") {
        return callback(new Error("邮箱地址不能为空"));
      } else if (this.emaiStatus != 0) {
        callback();
      } else {
        setTimeout(() => {
          if (!email.test(value)) {
            callback(new Error("请按要求填写邮箱地址"));
          } else {
            callback();
          }
        }, 1000);
      }
    };
    var checkOwnAlias = (rule, value, callback) => {
      var email = /^[a-zA-Z][a-zA-Z0-9_]{2,18}$/;
      if (!value) {
        callback(new Error("请输入个性化别名"));
      } else if (!email.test(value)) {
          callback(new Error("请按要求填写个性化别名"));
      } else {
        callback();
      }
    };
    var checkOfficeMail = (rule, value, callback) => {
      var email = /^[a-zA-Z][a-zA-Z0-9_]{2,18}$/;
      if (!value ) {
        callback(new Error("请输入校友邮箱"));
      } else if (!email.test(value)&&this.regInfo.officeMailStatus==1) {
        callback(new Error("请按要求填写校友邮箱"));
      } else {
        callback();
      }
    };

    var checkPwd = (rule, value, callback) => {
      const regPWD = /&|!|`|\\/;
      const regPWD2 = /\s/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!PwdPatrn(value)) {
        callback(new Error("密码格式不正确"));
      }else if(regPWD.test(value)){
        callback(new Error("密码格式不正确"));
      }else if(regPWD2.test(value)){
        callback(new Error("密码不能包含空格"));
      }else if(this.regInfo.officeMail && PwdPatrn2(value)!="-1"){
        callback(new Error("密码不能包含个性化别名"));
      } else {
        if (this.regInfo.pwd2 !== "") {
          this.$refs.regInfo.validateField("pwd2");
        }
        callback();
      }
    };
    var checkPwd2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.regInfo.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      successInfo: false,
      boxCloseInfo: false,
      userPrincipalName: "",
      errorMsg: "",
      regInfo: {
        xgh: "",
        name: "",
        pwd: "",
        pwd2: "",

        dataType: "",
        student_id: "",
        student_identification: "",
        alias: "",
        officeMail: "",
        officeMailStatus:1,
        aliasStr: "",
        ownAlias: "",

        officeExist:0
      },
      rules: {
        ownAlias: [{ validator: checkOwnAlias, trigger: "change" }],
        officeMail: [{ validator: checkOfficeMail, trigger: "change" }],

        pwd: [
          { validator: checkPwd, trigger: "change" },
          {
            min: 8,
            max: 16,
            message: "密码长度在 8 到 16 个字符",
            trigger: "change"
          }
        ],
        pwd2: [{ validator: checkPwd2, trigger: "change" }]
      }
    };
  },
  watch: {
    'regInfo.ownAlias': function (val) {
      if(this.regInfo.officeExist == 0 && val.substring(0,val.length-1) == this.regInfo.officeMail){
         this.regInfo.officeMail = val
      }
    },
  },
  methods: {



    //注册
    regEmail(regInfo) {
      let self = this;
      if (self.regInfo.xgh) {
        self.$refs["regInfo"].validate(valid => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: "正在注册中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            self.errorMsg = "";
            const password = self.regInfo.pwd;
            Array.prototype.indexOf = function(val) {
              for (var i = 0; i < this.length; i++) {
                if (this[i] == val) return i;
              }
              return -1;
            };

            Array.prototype.remove = function(val) {
              var index = this.indexOf(val);
              if (index > -1) {
                this.splice(index, 1);
              }
            };
            //所有的别名
            let allAlias = [];
            self.regInfo.alias.forEach(info => {
              allAlias.push(info);
            });
            allAlias.push(self.regInfo.ownAlias);
            const regEmailStatus = JSON.parse(
              localStorage.getItem("regEmailStatus")
            );
            const token = regEmailStatus.token;
            const personName = regEmailStatus.name;
            const orgId = regEmailStatus.orgId;
            const typeId = regEmailStatus.typeId;
            const url = "/email/regiterCoreemail";
            const _params = {
              userPrincipalName: self.regInfo.ownAlias,
              xgh: self.regInfo.xgh,
              alias: allAlias,
              officeMail: self.regInfo.officeMail,
              name: personName,       
              orgId: orgId,
              typeId: typeId,
              createUser: self.regInfo.xgh,
              dataType: self.regInfo.dataType,
              password: password,
              token: self.md5(token),
              officeExist: self.regInfo.officeExist,
            };
            const params = JSON.stringify(_params);
            self.postRequest(url, params).then(result => {
              loading.close();
              if (result.data.msgStatus == 1) {
                self.successInfo = true;
              } else if (result.data.msgStatus == 3) {
                self.errorMsg = "该个性化别名已存在";
              } else if (result.data.msgStatus == 4) {
                self.$alert(
                  "学校邮箱 " +
                    result.data.msgCode +
                    "@tongji.edu.cn 已注册，如若忘记密码，请先 <a href='/forgetPwd' style='color:#198bfd;text-decoration:underline;'>找回密码</a>",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    customClass: "errMessage",
                    callback: action => {
                      self.$router.push({ name: 'Home'})
                    }
                  }
                );
              } else if (result.data.msgStatus == 2) {
                self.$alert(result.data.msgCode, "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                  customClass: "errMessage"
                });
              } else if (result.data.msgStatus == 7) {
                self.$alert(
                  "手机号未录入系统，请联系校友会</br>邮箱： tjxyh@tongji.edu.cn",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    customClass: "errMessage"
                  }
                );
              } else if (result.data.msgStatus == 8) {
                self.$alert(
                  "校友邮箱已存在",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    customClass: "errMessage"
                  }
                );
              }else if (result.data.msgStatus == 9) {
                self.$alert(
                  "邮箱在保护时期，如需注册，请联系管理员",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    center: true,
                    customClass: "errMessage"
                  }
                );
              }else {
                self.$alert("系统错误,请重试", "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                  customClass: "errMessage"
                });
              }
            });
          }
        });
      } else {
        self.$alert("会话失效，请重新认证", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: action => {
            self.$router.push({ name: 'Home'})
          }
        });
      }
    }
  },
  mounted() {
    const self = this;
    const regEmailStatus = JSON.parse(localStorage.getItem("regEmailStatus"));
    if (regEmailStatus && regEmailStatus.uid && regEmailStatus.token && regEmailStatus.name && regEmailStatus.orgId) {
      const uid = regEmailStatus.uid;
      const token = regEmailStatus.token;
      const personName = regEmailStatus.personName;
      const orgId = regEmailStatus.orgId;
      const url =
        "/email/identification?personNo=" + uid + "&token=" + this.md5(token);
      self.postRequest(url, {}).then(result => {
        const _l = result.data.length;
        if (_l > 0) {
          const userInfo = result.data;
          let alias = [];
          let aliasStr = "";
          let name = "";
          let dataType = "";
          userInfo.forEach((info, key) => {
            if(info.officeMail){
              self.regInfo.officeMailStatus = 2;
              self.regInfo.emailActive = false;
              self.regInfo.officeExist = 1;
              var officeMail=info.officeMail.split("@");
              self.regInfo.officeMail = officeMail[0];
            }
            if (info.personSid) {
              if (info.personSid != uid) {
                if(info.flag){
                aliasStr += info.personSid + " , ";
                alias.push(info.personSid);
                }
                
              } else {
                name = info.personName;
                dataType = info.dataType;
              }
            }
          });    
          self.regInfo.aliasStr = aliasStr.substring(0, aliasStr.length - 2);
          //es6 数组去重
          self.regInfo.alias = Array.from(new Set(alias));
          self.regInfo.xgh = uid;
          self.regInfo.name = name;
          self.regInfo.dataType = dataType;

        }
      });
    } else {
      self.$router.push({ name: 'Home'})
      self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Home'})
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.regCoremailForm {
  margin-top: 38px;
  margin-bottom: 40px;
}
.emilName {
  color: #eb5468;
  font-size: 20px;
}
.emailAddr {
  width: 230px;
}
.emailName {
  display: inline-block;
  border: 1px solid #dcdfe6;
  width: 135px;
  text-align: center;
  margin-left: -12px;
  line-height: 38px;
}
.infoInput {
  width: 460px;
  height: 41px;
  margin: 0 auto;
  margin-top: 55px;
}
.infoInput.mt25 {
  margin-top: 25px;
}
.infoInput.mb75 {
  margin-bottom: 75px;
}
.tips {
  width: 365px;
  padding: 0;
  line-height: 25px;
  color: #999;
  font-size: 12px;
}
.infoBtn {
  margin: 0 auto;
  margin-top: 80px;
  text-align: center;
}
.infoBtn button {
  width: 310px;
}
.showBox .boxTitle {
  display: block;
  font-size: 20px;
  color: #778085;
  margin-left: 31px;
}
.showBox .boxBody {
  font-size: 16px;
  color: #778085;
  padding: 0 31px;
  word-break: break-all;
}
.showBox .boxBtn {
  display: block;
  width: 395px;
  margin: 0 auto;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  margin-bottom: 30px;
  background: #198bfd;
  color: #fff;
}
.showBox .boxBtn:hover {
  background: #66b1ff;
}
.mb75{
  margin-bottom: 75px;
}
</style>



// WEBPACK FOOTER //
// src/page/Coremail/reg/form.vue